import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent } from './page/error/error.component';
import { ErrorGuard } from './core/guards/error.guard';
import { StartupGuard } from './core/guards/startup.guard';

export const routes: Routes = [
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [ErrorGuard],
  },
  {
    path: '',
    loadChildren: () => import('./page/page.module').then(m => m.PageModule),
    canActivate: [StartupGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: false, // <-- debugging purposes only
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
